'use client';

import { useEffect } from 'react';

import { loggingError } from '@/shared/utils';

export default function GlobalError({
  error,
}: {
  error: Error & { digest?: string };
}) {
  useEffect(() => {
    loggingError(error, {
      message: 'Global Error',
    });
  }, [error]);

  return (
    <html>
      <body>
        <div className="bg-background text-foreground flex h-screen flex-col items-center justify-center px-6 text-center">
          <div className="animate-fade-in flex flex-col items-center gap-3">
            {/* 제목 & 설명 */}
            <h1 className="text-2xl font-bold">문제가 발생했어요</h1>
            <p className="text-muted-foreground max-w-md">
              죄송합니다. 예기치 못한 오류가 발생했습니다.
            </p>

            {/* 개발 환경용 오류 디테일 */}
            {process.env.NEXT_PUBLIC_APP_STAGE !== 'prod' && (
              <pre className="bg-muted mt-6 max-w-md overflow-x-auto whitespace-pre-wrap rounded-lg p-4 text-xs">
                {error?.message}
                {error?.digest && `\nDigest: ${error.digest}`}
              </pre>
            )}
          </div>
        </div>
      </body>
    </html>
  );
}
